import SecureLS from "secure-ls";

const ls = new SecureLS();

/**
 * Migrates existing authentication data from localStorage to encrypted SecureLS storage
 * This should run once when the app loads to handle existing users
 */
export function migrateAuthData() {
  try {
    // Check if migration is needed by looking for old localStorage data
    const oldToken = localStorage.getItem("token");
    const oldUserString = localStorage.getItem("user");

    // Only migrate if old data exists and new encrypted data doesn't
    const newToken = ls.get("token");
    const newUser = ls.get("user");

    if ((oldToken || oldUserString) && !newToken && !newUser) {
      console.log("Migrating authentication data to encrypted storage...");

      // Migrate token
      if (oldToken) {
        ls.set("token", oldToken);
        localStorage.removeItem("token");
        console.log("Token migrated successfully");
      }

      // Migrate user data
      if (oldUserString) {
        try {
          const oldUser = JSON.parse(oldUserString);
          ls.set("user", oldUser);
          localStorage.removeItem("user");
          console.log("User data migrated successfully");
        } catch (error) {
          console.error("Error parsing old user data:", error);
          localStorage.removeItem("user"); // Remove corrupted data
        }
      }

      console.log("Authentication data migration completed");
      return true;
    }

    return false; // No migration needed
  } catch (error) {
    console.error("Error during authentication data migration:", error);
    return false;
  }
}

/**
 * Clears all authentication data (both old and new formats)
 * Useful for complete logout/reset
 */
export function clearAllAuthData() {
  try {
    // Clear encrypted data
    ls.remove("token");
    ls.remove("user");
    ls.remove("permissions");

    // Clear any remaining localStorage data
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");

    console.log("All authentication data cleared");
  } catch (error) {
    console.error("Error clearing authentication data:", error);
  }
}
